/* ContactDetails.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Checkbox } from '@atlaskit/checkbox';
import { CheckboxField, Fieldset } from '@atlaskit/form';
import { media } from '@atlaskit/primitives/responsive';
import { H2 } from '@atlassian/mpac-primitives';
import { TextInput } from '@atlassian/mpac-ui';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _8 = "@media (min-width:48rem){._14b5tye8{width:20rem}}";
const _7 = "._1bsb1osq{width:100%}";
const _6 = "@media (min-width:48rem){._1r3v1epz{padding-left:var(--ds-space-1000,5pc)}}";
const _5 = "._19bvidpf{padding-left:0}";
const _4 = "@media (min-width:48rem){._6ytt47zb{padding:var(--_o3usm9)}}";
const _3 = "._k48p1wq8{font-weight:var(--ds-font-weight-medium,500)}";
const _2 = "._otyridpf{margin-bottom:0}";
const _ = "._1yt4zmd4{padding:var(--_1aun1c5)}";
const FieldsetTitleH2 = null;
const LeftPadding = null;
const FieldWidth20 = null;
export const ContactDetails = _ref => {
  let {
    submissionErrors
  } = _ref;
  return /*#__PURE__*/_jsx(Fieldset, {
    legend: /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_, _2, _3, _4]
      }), /*#__PURE__*/_jsx(H2, {
        className: ax(["_1yt4zmd4 _otyridpf _k48p1wq8 _6ytt47zb"]),
        style: {
          "--_1aun1c5": ix("var(--ds-space-300, 24px)".concat(" 0 ", "var(--ds-space-050, 4px)")),
          "--_o3usm9": ix("var(--ds-space-400, 32px)".concat(" 0 ", "var(--ds-space-025, 2px)"))
        },
        children: "Contact details"
      })]
    }),
    children: /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_5, _6]
      }), /*#__PURE__*/_jsxs("div", {
        className: ax(["_19bvidpf _1r3v1epz"]),
        children: [/*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_7, _8]
          }), /*#__PURE__*/_jsx("div", {
            className: ax(["_1bsb1osq _14b5tye8"]),
            children: /*#__PURE__*/_jsx(TextInput, {
              name: "email",
              label: "Email",
              width: "100%",
              isRequired: true,
              type: "email",
              helperMessage: "Provide an email address for your vendor profile.",
              applyDefaultValidation: true,
              testId: "email-input",
              submissionError: submissionErrors === null || submissionErrors === void 0 ? void 0 : submissionErrors.email
            })
          })]
        }), /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_7, _8]
          }), /*#__PURE__*/_jsx("div", {
            className: ax(["_1bsb1osq _14b5tye8"]),
            children: /*#__PURE__*/_jsx(TextInput, {
              name: "homepageUrl",
              label: "Homepage URL",
              type: "url",
              width: "100%",
              applyDefaultValidation: true,
              submissionError: submissionErrors === null || submissionErrors === void 0 ? void 0 : submissionErrors.homepageUrl
            })
          })]
        }), /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_7, _8]
          }), /*#__PURE__*/_jsx("div", {
            className: ax(["_1bsb1osq _14b5tye8"]),
            children: /*#__PURE__*/_jsx(TextInput, {
              name: "phone",
              label: "Phone",
              width: "100%",
              helperMessage: "Provide your full vendor phone number, including your country code.",
              submissionError: submissionErrors === null || submissionErrors === void 0 ? void 0 : submissionErrors.phone
            })
          })]
        }), /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_7, _8]
          }), /*#__PURE__*/_jsx("div", {
            className: ax(["_1bsb1osq _14b5tye8"]),
            children: /*#__PURE__*/_jsx(TextInput, {
              name: "otherContactDetails",
              label: "Other",
              width: "100%",
              submissionError: submissionErrors === null || submissionErrors === void 0 ? void 0 : submissionErrors.otherContactDetails
            })
          })]
        }), /*#__PURE__*/_jsx(CheckboxField, {
          name: "developerMailingList",
          children: _ref2 => {
            let {
              fieldProps
            } = _ref2;
            return /*#__PURE__*/_jsx(Checkbox, _objectSpread(_objectSpread({}, fieldProps), {}, {
              label: "Sign up for the developer mailing list",
              name: "developerMailingList"
            }));
          }
        })]
      })]
    })
  });
};